module.exports = __webpack_public_path__ + "static/media/DihorOtok_Main.6c38c4c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DihorOtok_Main.jpg
// module id = 347
// module chunks = 0